<template>
  <v-navigation-drawer
    stateless
    :value="show"
    absolute
    clipped
    left
    :width="$vuetify.breakpoint.smAndUp ? 320 : '100%'"
    style="left: 60px;"
    class="pt-1"
  >
    <v-toolbar flat dense>
      <v-toolbar-title class="grey--text">
        <v-btn icon small @click="$emit('close')">
          <v-icon small color="grey" style="transform: rotate(180deg);">double_arrow</v-icon>
        </v-btn>
      </v-toolbar-title>
    </v-toolbar>
    <template v-if="importantPages.length">
      <div class="mb-4">
        <v-subheader><v-icon small class="pr-2">bookmark</v-icon> Important Pages</v-subheader>
        <transition-group
          name="flip-list"
          v-on:before-enter="setAnimating(true)"
          v-on:after-enter="setAnimating(false)"
          v-on:before-leave="setAnimating(true)"
          v-on:after-leave="setAnimating(false)"
        >
          <page-list-item
            v-for="page in importantPages"
            :key="page.id"
            :ref="'important-' + page.id"
            class=""
            :item="page"
            :no-children="true"
          ></page-list-item>
        </transition-group>
      </div>
    </template>
    <v-subheader><v-icon small class="pr-2">list</v-icon> Outline</v-subheader>
    <page-list-item
      v-if="basePage"
      :key="basePage.id"
      :ref="basePage.id"
      class=""
      :item="basePage"
      :base="true"
    ></page-list-item>
  </v-navigation-drawer>
</template>

<script>
import PageListItem from './PageListItem';

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  components: { PageListItem },
  data() {
    return {
      childrenToHide: []
    };
  },
  props: ['show'],
  computed: {
    ...mapGetters('context', ['context', 'userCanEdit', 'sections']),
    ...mapState('views/context', ['selectedPageId', 'highlightedItems']),
    ...mapState('pages', ['pages']),
    basePage() {
      console.log(this.pages);
      return this.pages[this.context.basePage];
    },
    importantPages() {
      return Object.values(this.pages).filter(p => p.important);
    }
  },
  mounted() {
    //  Handle up and down keys when nothing is focused
    //window.addEventListener('keydown', this.handleBackgroundKeyEvents);
  },
  destroyed() {
    //window.removeEventListener('keydown', this.handleBackgroundKeyEvents);
  },
  methods: {
    ...mapMutations('views/context', ['setAnimating', 'setSelectedPageId']),
    ...mapMutations('components/dragdrop', ['setDragPosition', 'updateDraggedData']),
    ...mapActions('context', ['addSection']),
    focusEdit(id) {
      console.log(id);
      this.$nextTick(() => {
        this.$refs[id][0].enableEditing();
      });
    },
    async createNewSection() {
      const id = await this.addSection({
        contextId: this.context.id
      });
      console.log(id);
      this.$nextTick(() => {
        this.setSelectedPageId({ page: 'section-' + id });
        this.focusEdit(id);
      });
    },
    setupDrag({ event, ids, element, shift }) {
      // get the element and shift positions for dragHelper
      let html = '';
      //  Build the html drag element
      if (ids.length > 1) {
        ids.forEach(i => {
          try {
            html += this.$refs[i][0] ? this.$refs[i][0].$el.innerHTML : '';
          } catch (e) {
            //  no el;
          }
        });
      } else {
        console.log(this.$refs[ids[0]][0].$el);
        html = this.$refs[ids[0]][0].$refs.item.innerHTML;
      }

      // update drag data
      const dragObject = {
        element,
        shift,
        html,
        ids,
        types: ['question'],
        parent: {
          id: this.context.id,
          type: 'context'
        }
      };
      //  first set initial drag position
      const { x, y } = event;
      this.setDragPosition({ x, y });

      //  now set drag content
      this.updateDraggedData(dragObject);

      // //  setup move listeners
      // document.addEventListener('mousemove', this.updateDragPos);
      // document.addEventListener('mouseup', this.handleDragStop);
    },
    handleBackgroundKeyEvents(e) {
      //  handle global up/down if active element is body
      try {
        if (!this.editing && document.activeElement.tagName == 'BODY') {
          if ((e.which == 40 || e.which == 38) && !e.ctrlKey && !e.shiftKey) {
            console.log('handle bg key event');
            console.log(e);
            //  keydown
            let next;
            const dir = e.which == 40 ? 1 : -1;
            if (!this.selectedPageId) {
              next = { id: this.context.id };
            } else if (this.selectedPageId == this.context.id) {
              next = dir > 0 ? this.questions[0] : false;
            } else {
              const selected = this.questions.find(q => q.id == this.selectedPageId);
              if (selected.order == 0 && dir < 0) {
                next = { id: this.context.id };
              } else {
                next = this.questions.find(q => q.order == selected.order + dir);
              }
            }
            if (next) {
              this.setSelectedPageId({ page: next.id });
            }
          }
        }
      } catch (e) {
        console.log(e);
      }
    }
  }
};
</script>

<style>
.flip-list-move {
  transition: transform 0.3s, padding-left 0.3s;
}

.list-item-container {
  transition: padding-left 0.3s, transform 0.3s;
}

.flip-list-enter,
.flip-list-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.flip-list-leave-active {
  position: absolute !important;
}
</style>
